export const QUOTATION_FIELD_KEYS = {
  CLIENT_NAME: 'clientName',
  JOB_TITLE: 'clientTitle',
  EMAIL: 'email',
  PHONE: 'companyPhone',
  COMPANY_NAME: 'companyName',
  COMPANY_ADDRESS: 'companyAddress',
  TAX_CODE: 'taxCode',
}

export const IS_VALID_FIELDS = Object.assign(
  {},
  ...Object.keys(QUOTATION_FIELD_KEYS).map((item) => ({ [item]: true })),
)

export const ALL_QUOTATION_FIELDS = [
  {
    key: QUOTATION_FIELD_KEYS.CLIENT_NAME,
    title: 'userManagement.quotationInfo.CLIENT_NAME',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.JOB_TITLE,
    title: 'userManagement.quotationInfo.JOB_TITLE',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.EMAIL,
    title: 'userManagement.quotationInfo.EMAIL',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.PHONE,
    title: 'userManagement.quotationInfo.PHONE',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.COMPANY_NAME,
    title: 'userManagement.quotationInfo.COMPANY_NAME',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.COMPANY_ADDRESS,
    title: 'userManagement.quotationInfo.COMPANY_ADDRESS',
    value: '',
  },
  {
    key: QUOTATION_FIELD_KEYS.TAX_CODE,
    title: 'userManagement.quotationInfo.TAX_CODE',
    value: '',
  },
]
